import axios from 'axios';

export function saveDailyReport(data, token) {
    return axios.post('/report/save_daily_report', data, {
        headers: { Authorization: token }
    });
}

export function makeDailyReport(date, type, token) {
    return axios.get(`/report/make_daily_report/${type}/${date}`, {
        headers: { Authorization: token }
    });
}

export function loadDailyReport(date, token) {
    return axios.get(`/report/load_daily_report/${date}`, {
        headers: { Authorization: token }
    });
}

export function sendMailDailyReport(data, token) {
    return axios.post('/report/sent_mail_daily_report', data, {
        headers: { Authorization: token }
    });
}

export function updateFileAttachFile(file, branch, typeFile, token) {
    return axios.post("/report/upload-file/"+branch + "/" + typeFile, file, {
    headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token 
        },
    });
}
